module.exports = __webpack_public_path__ + "img/video_show.9846eb63.png";